import * as _ from 'underscore';

import { ScreenTypes } from 'Core/Common/Enums/ScreenTypes';
import {LABELS} from "Core/Components/Translation/Locales"

export enum ControlTypes { Search };

export enum KeyCodes { Enter = 13 };

export enum RenderModes { View, Edit, Design, ToolBar, Search, List, HelpView, GridRow };

export enum PortletRenderModes {View, Edit, Design};

export const LABEL_POSITIONS = {
	NoLabel: 'NoLabel',
	FullWidth: 'FullWidth'
};

export const FONT_STYLES = {
	BOLD: 'bold',
	NORMAL: '400',
	UNDERLINE: 'underline',
	ITALIC: 'italic'
}

export const PASSWORD = {
	MinimumLength: 8,
	DefaultValue: 'Empty'
};

export const CARD_SCREEN_PROPERTY_TYPE = {
	SCREEN_WIDTH: 'CardScreenWidthType',
	SCREEN_BACKGROUND_COLOR: 'CardScreenBackgroundColorType',
	FONT_COLOR: 'CardScreenFontColorType',
	FONT_WEIGHT: 'CardScreenFontWeightType',
	FONT_FAMILY: 'CardScreenFontFamilyType',
	FONT_STYLE: 'CardScreenFontStyleType',
};

export const SCREEN_PROPERTY_TYPE = {
	SCREEN_BACKGROUND_COLOR: 'ScreenBackgroundColorType',
	SCREEN_HEADER_BACKGROUND_COLOR: 'ScreenHeaderBackgroundColorType'
}

export const SYSTEM_FIELDS = ['F_TYPE', 'CREATEDATE', 'CREATEDBY', 'F_LIFESTATUS', 'CHANGEDATE', 'CHANGEDBY'];

export const SYSTEM_FIELD_NAMES = {
	F_TYPE: 'F_TYPE',
	F_KIND: 'F_KIND',
	CREATEDATE: 'CREATEDATE',
	CREATEDBY: 'CREATEDBY',
	F_LIFESTATUS: 'F_LIFESTATUS',
	CHANGEDATE: 'CHANGEDATE',
	CHANGEDBY: 'CHANGEDBY'
};

export const SYSTEM_TABLE_NAMES = {
	SYS_SEQUENCES: "SYS_SEQUENCES",
	SYS_USERS: "SYS_USERS",
	SYS_LOCKS: "SYS_LOCKS",
	SYS_GLOBALS: "SYS_GLOBALS",
	SYS_RIGHTS: "SYS_RIGHTS",
	SYS_SECURITY: "SYS_SECURITY",
	SYS_SESSIONS: "SYS_SESSIONS",
	SYS_THESAURI: "SYS_THESAURI",
	SYS_OBJECTS: "SYS_OBJECTS",
	SYS_QUEUES: "SYS_QUEUES",
	SYS_THINGS: "SYS_THINGS"
};

export const LIFESTATUS = {
	ENABLED: -1,
	DISABLED: 0
};

export const LIFE_STATUS_GROUPS = {
	PLANNED: 1000,
	ACQUIRED: 2000,
	OPERATIONAL: 3000,
	MAINTAINED: 4000,
	RETIRED: 5000,
	EXAMPLE: 6000,
	ERROR: 7000
};

export const TABLE_TYPES = {
	Entity: 'Entity',
	Sub: 'Sub',
	Link: 'Link',
	Lookup: 'Lookup'};

export const FIELD_TYPES = {
	YesNo: 'YesNo',
	Text: 'Text',
	Currency: 'Currency',
	Date: 'Date',
	DateTime: 'DateTime',
	Integer: 'Integer',
	Binary: 'Binary',
	Guid: 'Guid',
	Document: 'Document',
	Image: 'Image',
	Radio: 'Radio',
	MultiSelect:'MultiSelect',
	Icon: 'Icon',
	Type: 'Type',
	Time: 'Time',
	PKey: 'PKey',
	FlagCheck: 'FlagCheck',
	Lookup: 'Lookup',
	Sort: 'Sort',
	Memo: 'Memo',
	Password: 'Password',
	Color: 'Color',
	Decimal: 'Decimal',
	Alias: 'Alias',
	TimeSpan: 'TimeSpan',
	Reference: 'Reference',
	Spim: 'SPIM',
	Property: 'Property'
};

export var FIELD_TYPE_TO_CONTROL = {
	'YesNo': 'Checkbox',
	'Text': 'Text',
	'Currency': 'Currency',
	'Date': 'DateTime',
	'DateTime': 'DateTime',
	'Integer': 'Text',
	'Binary': 'Text',
	'Guid': 'Text',
	'Document': 'Document',
	'Image': 'Image',
	'Radio': 'RadioButton',
	'MultiSelect': 'MultiSelect',
	'Icon': 'Text',
	'Type': 'Text',
	'Time': 'DateTime',
	'TimeSpan': 'DateTime',
	'PKey': 'Text',
	'FlagCheck': 'FlagCheck',
	'Lookup': 'Dropdown',
	'Sort': 'Text',
	'Memo': 'Memo',
	'Password': 'Password',
	'Color': 'ColorSelector',
	'Decimal': 'Text',
	'Alias': 'Alias',
	'Reference': 'Text',
	'SPIM': 'Spim'
};

export const SortGroups = {
	Header: 'Header',
	OptionalHeader: 'OptionalHeader',
	Custom: 'Custom',
	OptionalFooter: 'OptionalFooter',
	Footer: 'Footer',
	Undefined: 'Undefined',

	GetSortGroup: (sort: number) => {
		if (_.include(_.range(1000, 1999), sort)) {
			return SortGroups.Header;
		}
		if (_.include(_.range(2000, 2999), sort)) {
			return SortGroups.OptionalHeader;
		}
		if (_.include(_.range(3000, 7999), sort)) {
			return SortGroups.Custom;
		}
		if (_.include(_.range(8000, 8999), sort)) {
			return SortGroups.OptionalFooter;
		}
		if (_.include(_.range(9000, 9999), sort)) {
			return SortGroups.Footer;
		}
		if (_.include([0], sort)) {
			return SortGroups.Undefined;
		}

		return null;
	},

	InCustom: (sort: number) => SortGroups.GetSortGroup(sort) === SortGroups.Custom
};

export const EVENTS = {
	ON_RECORD_SELECTED: 'OnRecordSelected',
	ON_ROW_CLICK: 'OnRowClick',
	ON_TAB_CLICK: 'OnTabClick',
	ON_PLANNER_PAGE_CLICK: 'OnPlannerPageClick',
	ON_SELECT_CHANGED: 'OnSelectChanged',
	ON_PAGE_CHANGED: 'OnPageChanged',
	ON_AFTER_RENDER: 'OnAfterRender',
	ON_CLOSE: 'OnClose',
	ON_DATA_SAVED: 'OnDataSaved',
	ON_TREE_NODE_SELECTED: 'OnTreeNodeSelected',
	QUERY_BUILDER: {
		ON_ENTTIY_SELECTED: 'OnEntitySelected'
	},
	PORTLETS: {
		RUNTIME_SETTINGS_APPLIED: 'RuntimeSettingsApplied',
		RUNTIME_SETTINGS_UPDATED: 'RuntimeSettingsUpdated',
		PORTLET_BAR: {
			CONTROL_BUTTONS: {
				REMOVE_BUTTON_CLICKED: 'RemoveButtonClicked',
				COLLAPSE_BUTTON_CLICKED: 'CollapseButtonClicked',
				EXPAND_BUTTON_CLICKED: 'ExpandButtonClicked',
				RELOAD_BUTTON_CLICKED: 'ReloadButtonClicked',
				SETTINGS_BUTTON_CLICKED: 'SettingsButtonClicked'
			}
		},
		EXPLORER_LOADED: 'OnExplorerLoaded',
		NEW_PORTLET_ADDED: 'NewPortletAdded',
		PORTLET_POSITION_CHANGED: 'PortletPositionChanged'
	}
} 

export var NotTypedScreenTypes = [ScreenTypes.ListScreen, ScreenTypes.SpecialScreen, ScreenTypes.Dashboard, ScreenTypes.QueryScreen, ScreenTypes.Portlet, ScreenTypes.CardScreen, ScreenTypes.StepsScreen];

export const CONTROL_TYPES =
{
    Text: 'Text',
    Dropdown: 'Dropdown',
    ButtonEdit: 'ButtonEdit',
    ButtonDelete: 'ButtonDelete',
	ButtonListScreen: 'ButtonListScreen',
	ButtonSpecialScreen: 'ButtonSpecialScreen',
	ButtonDashboardScreen: 'ButtonDashboardScreen',
    ButtonGoogleMaps: 'ButtonGoogleMaps',
	ButtonFollowUp: 'ButtonFollowUp',
	History: 'History',
    Tab: 'Tab',
    TabPage: 'TabPage',
    Image: 'Image',
    MultiSelect: 'MultiSelect',
    Checkbox: 'Checkbox',
    DateTime: 'DateTime',
    Drop: 'Drop',
    RadioButton: 'RadioButton',
    Grid: 'Grid',
    Group: 'Group',
    PortletBar: 'PortletBar',
    Label: 'Label',
    Memo: 'Memo',
    Document: 'Document',
    ButtonReturn: 'ButtonReturn',
    Kanban: 'Kanban',
    SelectUser: 'SelectUser',
    ButtonPrint: 'ButtonPrint',
    ButtonLinkedIn: 'ButtonLinkedIn',
    ButtonTree: 'ButtonTree',
    ButtonSecurityReset: 'ButtonSecurityReset',
    Password: 'Password',
    ColorSelector: 'ColorSelector',
    FlagCheck: 'FlagCheck',
    Agenda: 'Agenda',
    Mail: 'Mail',
	Scheduler:'Scheduler',
    LinkList: 'LinkList',
    DatabaseDesigner: 'DatabaseDesigner',
	FormDesigner: 'FormDesigner',
	CanvasDesigner: 'CanvasDesigner',
	FunctionDesigner: 'FunctionDesigner',
    LifestatusDesigner: 'LifestatusDesigner',
    QueryBuilder: 'QueryBuilder',
    TableSecurity: 'TableSecurity',
	TypeSecurity: 'TypeSecurity',
    RecordSecurity: 'RecordSecurity',
    UserSecurity: 'UserSecurity',
    UserAllowance: 'UserAllowance',
    RecordSharing: 'RecordSharing',
    ButtonFavorite: 'ButtonFavorite',
    Search: 'Search',
    ButtonCancel: 'ButtonCancel',
    ButtonSave: 'ButtonSave',
    TimeWriting: 'TimeWriting',
    ButtonTemplate: 'ButtonTemplate',
	TemplateDesigner: 'TemplateDesigner',
	RssFeed: 'RssFeed',
	Alias: 'Alias',
	CrystalViewer: 'CrystalViewer',
	Tag: 'Tag',
	FieldSecurity: 'FieldSecurity',
    ButtonConsultScreen: 'ButtonConsultScreen',
	ButtonAdd: 'ButtonAdd',
	Basket: 'Basket',
	QueryResult: 'QueryResult',
	PortletSpace: 'PortletSpace',
	TimeSpan: 'TimeSpan',
	GanttChart: 'GanttChart',
	BulkEmail: 'BulkEmail',
    GenericButton: 'GenericButton',
	Invoicing: 'Invoicing',
	FinancialDashboard: 'FinancialDashboard',
	ButtonCopy: 'ButtonCopy',
	Currency: 'Currency',
	Planner: 'Planner',
	PlannerPage: 'PlannerPage',
	PlannerLevel: 'PlannerLevel',
	IFrame: 'IFrame',
	ProductConfigurator: 'ProductConfigurator',
	Spim: 'Spim',
	SpimCopy: 'SPIMCopy',
	Book: 'Book',
	Timer: 'Timer',
	Signature: 'Signature',
	Spreadsheet: 'Spreadsheet',
	Chart: 'Chart',
	RecipeEditor: 'RecipeEditor',
	Maps: 'Maps',
	IFrameExtension: 'IFrameExtension',
	Step: 'Step',
	StepPage: 'StepPage',
	ButtonPlan: 'ButtonPlan'
};

export const SIMPLE_CONTROLS = [
	CONTROL_TYPES.Text,
	CONTROL_TYPES.DateTime,
	CONTROL_TYPES.Dropdown,
	CONTROL_TYPES.Memo,
	CONTROL_TYPES.Checkbox,
	CONTROL_TYPES.FlagCheck,
	CONTROL_TYPES.ColorSelector,
	CONTROL_TYPES.RadioButton,
	CONTROL_TYPES.MultiSelect,
	CONTROL_TYPES.Currency
];

export const SECURITY_CONTROLS = [
	CONTROL_TYPES.TableSecurity,
	CONTROL_TYPES.TypeSecurity,
	CONTROL_TYPES.RecordSecurity,
	CONTROL_TYPES.RecordSharing,
	CONTROL_TYPES.UserSecurity,
	CONTROL_TYPES.UserAllowance,
	CONTROL_TYPES.Password,
	CONTROL_TYPES.FieldSecurity
];

export const DEFAULT_ICONS = {
	Agenda: {
		Name: "fa fa-calendar-check-o",
		FontName: "fa fa-3x fa-stack",
		Image: null,
		IsIcon: true,
		IsImage: false,
		Id: null
	},
	Drop: {
		Name: "fa fa-newspaper-o",
		FontName: "fa fa-3x fa-stack",
		Image: null,
		IsIcon: true,
		IsImage: false,
        Id: null
	},
	Tag: {
		Name: "fa fa-tags",
		FontName: "fa fa-3x fa-stack",
		Image: null,
		IsIcon: true,
		IsImage: false,
        Id: null
	},
	QueryBuilder: {
		Name: null,
		FontName: null,
		Image: "data:image/png;base64,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",
		IsIcon: false,
		IsImage: true,
        Id: null
	},
	Invoicing: {
		Name: "fa fa-calculator",
		FontName: "fa fa-3x fa-stack",
		Image: null,
		IsIcon: true,
		IsImage: false,
		Id: null
	},
	ProductConfigurator: {
		Name: "fa fa-industry",
		FontName: "fa fa-3x fa-stack",
		Image: null,
		IsIcon: true,
		IsImage: false,
		Id: null
	},
	Scheduler: {
		Name: "fa fa-calendar-o",
		FontName: "fa fa-3x fa-stack",
		Image: null,
		IsIcon: true,
		IsImage: false,
		Id: null
	},
	TimeWriting: {
		Name: "glyphicon glyphicon-time",
		FontName: "fa fa-3x fa-stack",
		Image: null,
		IsIcon: true,
		IsImage: false,
		Id: null
	},
	BulkMail: {
		Name: "fa fa-envelope",
		FontName: "fa fa-3x fa-stack",
		Image: null,
		IsIcon: true,
		IsImage: false,
		Id: null
	},
	Basket: {
		Name: "fa fa-shopping-basket",
		FontName: "fa fa-3x fa-stack",
		Image: null,
		IsIcon: true,
		IsImage: false,
		Id: null
	},
	ButtonTemplate: {
		Name: "fa fa-file",
		FontName: "fa fa-3x fa-stack",
		Image: null,
		IsIcon: true,
		IsImage: false,
		Id: null
	},
	Document: {
		Name: "fa fa-file-text-o",
		FontName: "fa fa-3x fa-stack",
		Image: null,
		IsIcon: true,
		IsImage: false,
		Id: null
	},
	Kanban: {
		Name: "fa fa-compress",
		FontName: "fa fa-3x fa-stack",
		Image: null,
		IsIcon: true,
		IsImage: false,
		Id: null
	},
	Mail: {
		Name: "fa fa-envelope-o",
		FontName: "fa fa-3x fa-stack",
		Image: null,
		IsIcon: true,
		IsImage: false,
		Id: null
	},
	Gantt: {
		Name: "fa fa-bar-chart",
		FontName: "fa fa-3x fa-stack",
		Image: null,
		IsIcon: true,
		IsImage: false,
		Id: null
	}
};

export enum FONT_NAME {
    FONT_AWESOME = 'fontawesome-webfont',
    SIMPLE_LINE = 'Simple-Line-Icons',
    SOCIAL_ICONS = 'Social-Icons',
    GRAPHICAL = 'Graphical'
}

export enum ICON_NAME {
	EMPTY_ICON = 'empty-icon'
}

export const CLUSTERED_MODES = {
	COPY: {
		Value: 0
	},
	DEFAULT: {
		Value: 1
	},
	DELTA: {
		Value: 2
	}
};

export const DELETION_MODES = {
	ASK: {
		Id: 0,
		Name: 'Ask'
	},
	PRESERVE: {
		Id: 1,
		Name: 'Preserve'
	},
	DELETE: {
		Id: 2,
		Name: 'Delete'
	}
};